
export enum EUserStatus {
    PENDING = 'Pending',
    ACTIVE = 'Active',
    INACTIVE = 'Inactive',
    BANNED = 'Banned',
    INITIATED = 'Initiated',
}

export enum EFeatures {
    ADMIN = 'User Management',
    EXCEPTION_MANAGEMENT = 'Data Management',
    LIVE_TRACKING = 'Live Tracking',
    EVENT_TRACKING = 'Event Tracking',
    ALERT_SUBSCRIPTION = 'Alert Subscription',
    REPORTING = 'Reporting',
    DSM_SHIPMENT_REPUSH = 'Shipment Re-push',
    VESSEL_MANAGEMENT = 'Vessel Management',
    DATA_UPLOAD = "Upload",
    RISK_MONITOR = 'Risk Monitor Viewer',
    NAV_GPT = "Nav Gpt",
    ANALYTICS = 'Analytics',
    SCHEDULE_MANAGEMENT = 'Schedule Management',
    SMART_NAVIGATOR_VIEWER = 'Smart Navigator Viewer',
    PETA_MANAGEMENT = 'PETA Management',
    MASTER_DATA_MANAGER = 'Master Data Manager'
}

export enum FileStatus {
    REJECTED = "Rejected",
    FULLY_ACCEPTED = "Fully Accepted",
    PARTIALLY_ACCEPTED = "Partially Accepted",
    SUBMITTED = "Submitted"
}
export enum EConfig {
    FEATURES = "Features",
    COMPANIES = "Companies",
    ETA_THRESHOLD = "ETA_Threshold",
    KEY_REFERENCE = "Key_Reference",
    GROUP = 'Group',
    SALES_TERM = 'Sales_Term',
    MASTER_EVENTS = 'Master_Events',
    MODE = 'Mode',
    VESSEL = 'Vessel',
    LOCATION = 'Location'
}

export enum EErrorAction {
    RESOLVE = "Resolved",
    IGNORE = "Ignored",
    OPEN = "Open",
}

export enum EErrorCategory {
    CARRIER_SCAC = "Carrier SCAC",
    VESSEL_NAME = "Vessel Name",
    CONTAINER_COUNT = "Container Count",
    BOL_NUMBER = "BOL",
    CONTAINERS = "Container ID's",
    IGNORED_ERRORS = "Ignored Errors",
    PORTS = "Ports",
    DATE_DIFFERENTIAL = "Date Differential",
    RESOLVED_ERRORS = "Resolved Errors",
    EVENTS = "Events",
    MISSING_UNLOC = "Missing UNLOC",
    MISSING_VESSELS = "Missing Vessels",
    BOL_AND_BOOKING = "BOL and Booking No.",
    CARRIER_SCAC_NOT_SETUP = "Carrier Not setup",
    CONTAINER_MISMATCH = "Container Mismatch",
    INVALID_BOL = "Invalid BOL",
    INVALID_VESSEL_NAME = "Invalid Vessel Name",
    CARRIER_NOT_SUPPORTED = "Carrier Not supported"
}

export enum EFenceType {
    ANCHOR = "Anchor",
    TERMINAL = "Terminal",
    YARD = 'Yard',
    WAREHOUSE = 'Warehouse',
    PLANT = 'Plant',
}

export enum EFenceAreaType {
    CIRCLE = "CIRCLE",
    POLYGON = "POLYGON",
    RECTANGLE = "RECTANGLE"
}

export enum EFenceMode {
    POINT = 'draw_point',
    CIRCLE = "draw_circle",
    SELECT = 'simple_select',
    POLYGON = "draw_polygon",
    LINE = 'draw_line_string',
    RECTANGLE = "draw_rectangle",
    SCALE_ROTATE = "scaleRotateMode",
}

export enum EAlertsType {
    PRE_DEPARTURE = 1,
    IN_TRANSIT = 2,
    POST_ARRIVAL = 3,
}

export enum ERiskUserType {
    RISK_VIEWER = 15,
    RISK_APPROVER = 16,
    RISK_EVENTS_MANAGER = 17,
    RISK_ASSET_MANAGER = 18,
    RISK_COMMODITY_MANAGER = 25,
    RISK_SUPPLIER_DASHBOARD = 26,
    RISK_CUSTOMIZED_DASHBOARD = 27
    // RISK_QUERY_MANAGER =
}

export enum ERiskUser {
    RISK_VIEWER = 'RISK_VIEWER',
    RISK_EDITOR = 'RISK_EDITOR'
}
export enum BdpServiceCode{
        IMPORT = 'I',
        EXPORT = 'E'
      }
